import { Link, Outlet, useLocation } from "react-router-dom";
import { Activity, Terminal, Zap } from "lucide-react";
import { cn } from "@/lib/utils";

const debugTabs = [
  { label: "Overview", to: "/admin/debug", icon: Activity, exact: true },
  { label: "Backend", to: "/admin/debug/backend", icon: Terminal },
  { label: "Execution", to: "/admin/debug/execution", icon: Zap },
];

export default function AdminDebug() {
  const { pathname } = useLocation();
  const isIndex = pathname === "/admin/debug";

  return (
    <div className="container px-6 py-8 relative">
      {/* Sub-tabs */}
      <div className="flex items-center gap-1 mb-6 border-b border-border pb-3">
        {debugTabs.map((tab) => {
          const active = tab.exact ? pathname === tab.to : pathname.startsWith(tab.to);
          const Icon = tab.icon;
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={cn(
                "flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-md transition-colors",
                active
                  ? "bg-primary/10 text-primary"
                  : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
              )}
            >
              <Icon className="h-3.5 w-3.5" />
              {tab.label}
            </Link>
          );
        })}
      </div>

      <Outlet />
    </div>
  );
}
